
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as loginIShghKLnEF7Y1jsj8VmdBCy6EEOvIWCh_wwetWv2tqgMeta } from "/Users/camo/Documents/Proyectos/bm-repo/boxmagic/clientes/auth/appNuxt/pages/login.vue?macro=true";
import { default as restablecer6mZ3YZWBN8Z3m_eW3n8lZ6h0yPCmiGWx7m_GrfdfHhwMeta } from "/Users/camo/Documents/Proyectos/bm-repo/boxmagic/clientes/auth/appNuxt/pages/restablecer.vue?macro=true";
import { default as studentWiQ3O4bqYBDvAV_3zc5bcLwdQzuRdyIxYvJdsnxlejgMeta } from "/Users/camo/Documents/Proyectos/bm-repo/boxmagic/clientes/auth/appNuxt/pages/student.vue?macro=true";
import { default as botonesPbHfw5Yw2Y6kNwvCyVQstZpppKuDIn61xU0CfREgq48Meta } from "/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui/componentes/botones.vue?macro=true";
import { default as botones25DXMxrIb1vefyqKHmQleVwGOpfda6RlhDOHXDT8VtzCxEMeta } from "/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui/componentes/botones25D.vue?macro=true";
import { default as botonesPlanostKO_CAwJb8Rsdd91fTRZw_VR4TwgnQgAKlEmBOM0bHAMeta } from "/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui/componentes/botonesPlanos.vue?macro=true";
import { default as calendarioIIf3A86gxSiBpreZDPlTHVlyp_qJvzNE0S0rhQFBfSwMeta } from "/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui/componentes/calendario.vue?macro=true";
import { default as divswqOiUFiIY_ETumGMjBOZk_dm9VgZQSYTKcjxzLH51ooMeta } from "/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui/componentes/divs.vue?macro=true";
import { default as inputs28m8f6cIbxfvXF56KuEbzKexLMMVrWKkUoNjTflHl9UMeta } from "/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui/componentes/inputs.vue?macro=true";
import { default as linksftQ4YNj2gx2KOCDWiRHIWozJILoAGWLtu3nV3otD1dAMeta } from "/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui/componentes/links.vue?macro=true";
import { default as tarjetasfOPNy63IjRMtCsaNlLf2Pc01I_44OjTZfqDNds2aidYMeta } from "/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui/componentes/tarjetas.vue?macro=true";
import { default as videosWfGx_R_KWLCa3pA7ozG53Onl0hiSAsfFdeLPK49EkA8Meta } from "/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui/componentes/videos.vue?macro=true";
import { default as indexvORa2rbAwMEbZosppJktqZCqGWwmit4cfOLI8m_xnn0Meta } from "/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui/componentes/index.vue?macro=true";
import { default as conMenuWqJo80eFMapcfKYz6vBd2dpajXEiVH7aDZOTOdobgpYMeta } from "/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui/conMenu.vue?macro=true";
import { default as editor_45tema1YmGbTpTJyPVR5rbNA7zYbxzkOItNCKBM2L_YQrCfXsMeta } from "/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui/editor-tema.vue?macro=true";
import { default as temaNqcpbRV_Psalb2fUpqHR2A6qghGssAEpsZbEH8IXPO4Meta } from "/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui/tema.vue?macro=true";
import { default as texto0qewSqHKpPk6o8eqUY8rEfHpCe_AUJ9ALHMjBMlMd5EMeta } from "/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui/texto.vue?macro=true";
import { default as index0AbiM__Qh_6l2tSjeX0Ok0BNSj9ywNk3_kVuAFBrQR4Meta } from "/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui/index.vue?macro=true";
import { default as visor_45uiTNNkxBKbFt_Ec5rFqdX9_1Bh9OvyUkuIS6mrOkVzBHcMeta } from "/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui.vue?macro=true";
import { default as indexqP6WcsuF_PDaaAyR2VqzUteyCEst3yObCuvNQUTkK90Meta } from "/Users/camo/Documents/Proyectos/bm-repo/boxmagic/clientes/auth/appNuxt/pages/index.vue?macro=true";
import { default as component_45stubj6VAu04qbL8JG_3RWwTcvBQnaq9SZYK5t5UQuLE_LlIMeta } from "/Users/camo/Documents/Proyectos/bm-repo/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubj6VAu04qbL8JG_3RWwTcvBQnaq9SZYK5t5UQuLE_LlI } from "/Users/camo/Documents/Proyectos/bm-repo/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "login",
    path: "/login",
    component: () => import("/Users/camo/Documents/Proyectos/bm-repo/boxmagic/clientes/auth/appNuxt/pages/login.vue")
  },
  {
    name: "restablecer",
    path: "/restablecer",
    component: () => import("/Users/camo/Documents/Proyectos/bm-repo/boxmagic/clientes/auth/appNuxt/pages/restablecer.vue")
  },
  {
    name: "student",
    path: "/student",
    component: () => import("/Users/camo/Documents/Proyectos/bm-repo/boxmagic/clientes/auth/appNuxt/pages/student.vue")
  },
  {
    name: "VisorUI",
    path: "/visor-ui",
    component: () => import("/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui.vue"),
    children: [
  {
    name: "visor-ui-componentes-botones",
    path: "componentes/botones",
    component: () => import("/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui/componentes/botones.vue")
  },
  {
    name: "visor-ui-componentes-botones25D",
    path: "componentes/botones25D",
    component: () => import("/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui/componentes/botones25D.vue")
  },
  {
    name: "visor-ui-componentes-botonesPlanos",
    path: "componentes/botonesPlanos",
    component: () => import("/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui/componentes/botonesPlanos.vue")
  },
  {
    name: "visor-ui-componentes-calendario",
    path: "componentes/calendario",
    component: () => import("/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui/componentes/calendario.vue")
  },
  {
    name: "visor-ui-componentes-divs",
    path: "componentes/divs",
    component: () => import("/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui/componentes/divs.vue")
  },
  {
    name: "visor-ui-componentes-inputs",
    path: "componentes/inputs",
    component: () => import("/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui/componentes/inputs.vue")
  },
  {
    name: "visor-ui-componentes-links",
    path: "componentes/links",
    component: () => import("/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui/componentes/links.vue")
  },
  {
    name: "visor-ui-componentes-tarjetas",
    path: "componentes/tarjetas",
    component: () => import("/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui/componentes/tarjetas.vue")
  },
  {
    name: "visor-ui-componentes-videos",
    path: "componentes/videos",
    component: () => import("/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui/componentes/videos.vue")
  },
  {
    name: "visor-ui-componentes",
    path: "componentes",
    component: () => import("/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui/componentes/index.vue")
  },
  {
    name: "visor-ui-conMenu",
    path: "conMenu",
    component: () => import("/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui/conMenu.vue")
  },
  {
    name: "visor-ui-editor-tema",
    path: "editor-tema",
    component: () => import("/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui/editor-tema.vue")
  },
  {
    name: "visor-ui-tema",
    path: "tema",
    component: () => import("/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui/tema.vue")
  },
  {
    name: "visor-ui-texto",
    path: "texto",
    component: () => import("/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui/texto.vue")
  },
  {
    name: "visor-ui",
    path: "",
    component: () => import("/Users/camo/Documents/Proyectos/bm-repo/front/layers/base/pages/visor-ui/index.vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    meta: indexqP6WcsuF_PDaaAyR2VqzUteyCEst3yObCuvNQUTkK90Meta || {},
    component: () => import("/Users/camo/Documents/Proyectos/bm-repo/boxmagic/clientes/auth/appNuxt/pages/index.vue")
  },
  {
    name: component_45stubj6VAu04qbL8JG_3RWwTcvBQnaq9SZYK5t5UQuLE_LlIMeta?.name,
    path: "/signin",
    component: component_45stubj6VAu04qbL8JG_3RWwTcvBQnaq9SZYK5t5UQuLE_LlI
  },
  {
    name: component_45stubj6VAu04qbL8JG_3RWwTcvBQnaq9SZYK5t5UQuLE_LlIMeta?.name,
    path: "/signup",
    component: component_45stubj6VAu04qbL8JG_3RWwTcvBQnaq9SZYK5t5UQuLE_LlI
  },
  {
    name: component_45stubj6VAu04qbL8JG_3RWwTcvBQnaq9SZYK5t5UQuLE_LlIMeta?.name,
    path: "/soporte",
    component: component_45stubj6VAu04qbL8JG_3RWwTcvBQnaq9SZYK5t5UQuLE_LlI
  }
]